export default __webpack_public_path__ + "static/media/delete.e8434241.svg";